import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import IMetadata from '../../../../_interfaces/IMetadata';
import { ErrorsService } from '../../../../_services/errors/errors.service';
import { PatientsMetadataService } from '../../../../_services/patients/patients-metadata.service';
import { SessionService } from '../../../../_services/session/session.service';
import { BaseComponent } from '../../../../components/base/base.component';

@Component({
  standalone: true,
  selector: 'app-create-metadata-boolean',
  templateUrl: './create-metadata-boolean.component.html',
  styleUrls: ['./create-metadata-boolean.component.scss'],
  imports: [TranslatePipe, FormsModule, ButtonModule],
})
export class CreateMetadataBooleanComponent extends BaseComponent {
  public metadata: IMetadata;

  constructor(
    public patientMetadataService: PatientsMetadataService,
    public translate: TranslateService,
    public messageService: MessageService,
    public errorsService: ErrorsService,
    public session: SessionService
  ) {
    super(session);
  }

  save() {
    this.patientMetadataService
      .create(this.customers_id, this.metadata)
      .subscribe({
        next: () => {
          this.clear();
          this.messageService.add({
            severity: 'success',
            detail: this.translate.instant('MESSAGES.METADATA.CREATE.DETAIL'),
            summary: this.translate.instant('MESSAGES.METADATA.CREATE.SUMMARY'),
          });
        },
        error: (error) => {
          const code = this.errorsService.getMessageFromMetadataError(error);
          this.messageService.add({
            summary: this.translate.instant('MESSAGES.METADATA.ERROR.SUMMARY'),
            detail: this.translate.instant(`MESSAGES.METADATA.ERROR.${code}`),
            severity: 'error',
          });
        },
      });
  }

  clear() {
    this.metadata = {
      customers_id: this.customers_id,
      metadata_types_id: 6,
      name: undefined,
      default: undefined,
      options: [
        {
          name: 'COMMON.YES',
          default: false,
        },
        {
          name: 'COMMON.NO',
          default: true,
        },
      ],
    };
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.clear();
  }
}
